import { createWithEqualityFn } from "zustand/traditional";
import type { BranchParams } from "react-native-branch";

type BranchState = {
  branch_link: string | null;
  marketing_title: string | null;
  tags: string[];
  link_title: string | null;
  channel: string | null;
  feature: string | null;
  campaign: string | null;
  setBranchParams: (branchParams: BranchParams) => void;
  reset: () => void;
};

export const useBranchStore = createWithEqualityFn<BranchState>((set, get) => ({
  branch_link: null,
  marketing_title: null,
  tags: [],
  link_title: null,
  channel: null,
  feature: null,
  campaign: null,

  setBranchParams: (branchParams?: BranchParams) => {
    if (!branchParams) return;

    const link =
      (branchParams["original_branch_link"] as string | undefined) ??
      branchParams["~referring_link"];
    if (!link) return;

    console.log("::branch store:: storing branch params", branchParams);
    const withoutQueryParams = link.split("?")[0];
    const withNormalizedDomain = withoutQueryParams?.replace(
      "lsn-alternate.app.link",
      "lsn.app.link",
    );

    // Only update if we don't have existing valid data for this session
    const currentState = get();
    if (currentState.branch_link && withNormalizedDomain === null) {
      return;
    }

    const newState = {
      branch_link: withNormalizedDomain,
      marketing_title: branchParams["$marketing_title"]?.toString() ?? null,
      tags: branchParams["~tags"] ?? [],
      link_title: branchParams["$link_title"]?.toString() ?? null,
      channel: branchParams["~channel"]?.toString() ?? null,
      feature: branchParams["~feature"]?.toString() ?? null,
      campaign: branchParams["~campaign"]?.toString() ?? null,
    };

    // Only set if we have actual branch data
    if (withNormalizedDomain) {
      set(newState);
    }
  },

  reset: () => {
    set({
      branch_link: null,
      marketing_title: null,
      tags: [],
      link_title: null,
      channel: null,
      feature: null,
      campaign: null,
    });
  },
}));
